import { bindActionCreators } from "redux";
import { changeAgentChatStatusApi } from "redux/ringme-ott-sdk";
import { call, put, select, take } from "redux-saga/effects";

import * as cookie from "../ultis/cookies";
import * as apiCaller from "./../api/apiCaller";
import { globalHistory } from "./../history";
/**
 * Consts
 */

export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";

export const GET_ALL_USER = "GET_ALL_USER";
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_ERROR = "GET_ALL_USER_ERROR";

export const GET_SUB_ORG = "GET_SUB_ORG";
export const GET_SUB_ORG_SUCCESS = "GET_SUB_ORG_SUCCESS";
export const GET_SUB_ORG_ERROR = "GET_SUB_ORG_ERROR";

export const FIND_PROVINCE = "FIND_PROVINCE";
export const FIND_PROVINCE_SUCCESS = "FIND_PROVINCE_SUCCESS";
export const FIND_PROVINCE_ERROR = "FIND_PROVINCE_ERROR";

export const GET_ALL_USER_HISTORY = "GET_ALL_USER_HISTORY";
export const GET_ALL_USER_HISTORY_SUCCESS = "GET_ALL_USER_HISTORY_SUCCESS";
export const GET_ALL_USER_HISTORY_ERROR = "GET_ALL_USER_HISTORY_ERROR";

export const COUNT_USER = "COUNT_USER";
export const COUNT_USER_SUCCESS = "COUNT_USER_SUCCESS";
export const COUNT_USER_ERROR = "COUNT_USER_ERROR";

export const ADD_USER = "ADD_USER";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_ERROR = "ADD_USER_ERROR";

export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_ERROR = "EDIT_USER_ERROR";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const GET_INFO = "GET_INFO";
export const GET_INFO_SUCCESS = "GET_INFO_SUCCESS";
export const GET_INFO_ERROR = "GET_INFO_ERROR";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const CHANGE_PROFILE = "CHANGE_PROFILE";
export const CHANGE_PROFILE_SUCCESS = "CHANGE_PROFILE_SUCCESS";
export const CHANGE_PROFILE_ERROR = "CHANGE_PROFILE_ERROR";

export const GET_USER_HISTORY_LOG = "GET_USER_HISTORY_LOG";
export const GET_USER_HISTORY_LOG_SUCCESS = "GET_USER_HISTORY_LOG_SUCCESS";
export const GET_USER_HISTORY_LOG_ERROR = "GET_USER_HISTORY_LOG_ERROR";

export const COUNT_USER_HISTORY_LOG = "COUNT_USER_HISTORY_LOG";
export const COUNT_USER_HISTORY_LOG_SUCCESS = "COUNT_USER_HISTORY_LOG_SUCCESS";
export const COUNT_USER_HISTORY_LOG_ERROR = "COUNT_USER_HISTORY_LOG_ERROR";
/**
 * Reducer
 */

const initialState = {
  users: [],
  subOrgs: [],
  foundProvinces: [],
  user: {},
  count: 0,
  loadingHistory: false,
  histories: [],
  countHistory: 0,
  allUser: [],
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_ORG:
      return {
        ...state,
      };

    case GET_SUB_ORG_SUCCESS:
      return {
        ...state,
        subOrgs: action.payload,
      };

    case GET_SUB_ORG_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case FIND_PROVINCE:
      return {
        ...state,
        findLoading: true,
      };
    case FIND_PROVINCE_SUCCESS:
      return {
        ...state,
        foundProvinces: action.payload,
        findLoading: false,
      };
    case FIND_PROVINCE_ERROR:
      return {
        ...state,
        foundProvinces: [],
        findLoading: false,
        error: action.error,
      };
    //get all
    case GET_ALL_USER:
      return {
        ...state,
      };

    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };

    case GET_ALL_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_ALL_USER_HISTORY:
      return {
        ...state,
      };

    case GET_ALL_USER_HISTORY_SUCCESS:
      return {
        ...state,
        allUser: action.payload,
      };

    case GET_ALL_USER_HISTORY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case ADD_USER:
      return {
        ...state,
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        // users: action.payload
      };

    case ADD_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case COUNT_USER:
      return {
        ...state,
      };

    case COUNT_USER_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };

    case COUNT_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case EDIT_USER:
      return {
        ...state,
      };

    case EDIT_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };

    case EDIT_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case DELETE_USER:
      return {
        ...state,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };

    case DELETE_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case CHANGE_PASSWORD:
      return {
        ...state,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        password: action.payload,
      };

    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //change profile
    case CHANGE_PROFILE:
      return {
        ...state,
      };

    case CHANGE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };

    case CHANGE_PROFILE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //getinfo
    case GET_INFO:
      return { ...state };

    case GET_INFO_SUCCESS:
      return { ...state, info: action.payload };

    case GET_INFO_ERROR:
      return { ...state, error: action.error };
    //logout
    case LOGOUT:
      return { ...state };

    case LOGOUT_SUCCESS:
      return { ...state, logout: action.payload };

    case LOGOUT_ERROR:
      return { ...state, error: action.error };

    case GET_USER_HISTORY_LOG:
      return {
        ...state,
        loadingHistory: true,
      };

    case GET_USER_HISTORY_LOG_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        histories: action.payload,
      };

    case GET_USER_HISTORY_LOG_ERROR:
      return {
        ...state,
        loadingHistory: false,
        error: action.error,
      };

    case COUNT_USER_HISTORY_LOG:
      return {
        ...state,
      };

    case COUNT_USER_HISTORY_LOG_SUCCESS:
      return {
        ...state,
        countHistory: action.payload,
      };

    case COUNT_USER_HISTORY_LOG_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Actions
 */

// const getUser = () => ({
//     type: GET_USER,
// })

const getAllUser = (order, limit, skip, where) => ({
  type: GET_ALL_USER,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

const getSubOrg = () => ({
  type: GET_SUB_ORG,
});

export const findProvince = (name, limit) => ({
  type: FIND_PROVINCE,
  data: { name, limit },
});

const getAllUserHistory = () => ({
  type: GET_ALL_USER_HISTORY,
});

const getUserHistory = (order, limit, skip, where) => ({
  type: GET_USER_HISTORY_LOG,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

const countUserHistory = (where) => ({
  type: COUNT_USER_HISTORY_LOG,
  data: {
    where,
  },
});

const countUser = (where) => ({
  type: COUNT_USER,
  data: {
    where,
  },
});

const addUser = (
  username,
  password,
  fullname,
  email,
  phoneNumber,
  status,
  role,
  subOrg,
  isActiveChat
) => ({
  type: ADD_USER,
  data: {
    username,
    password,
    fullname,
    email,
    phoneNumber,
    status,
    role,
    subOrg,
    isActiveChat,
  },
});

const editUser = (
  id,
  username,
  password,
  fullname,
  email,
  phoneNumber,
  status,
  role,
  subOrg,
  isActiveChat
) => ({
  type: EDIT_USER,
  data: {
    id,
    username,
    password,
    fullname,
    email,
    phoneNumber,
    status,
    role,
    subOrg,
    isActiveChat,
  },
});

const changePassword = (oldPassword, newPassword) => ({
  type: CHANGE_PASSWORD,
  data: {
    oldPassword,
    newPassword,
  },
});

const getInfo = () => ({
  type: GET_INFO,
});

const logout = () => ({
  type: LOGOUT,
});

const deleteUser = (id) => ({
  type: DELETE_USER,
  data: {
    id,
  },
});

const changeProfile = (fullname, phoneNumber, address) => ({
  type: CHANGE_PROFILE,
  data: {
    fullname,
    phoneNumber,
    address,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getUser,
      changePassword,
      getAllUser,
      getInfo,
      logout,
      addUser,
      editUser,
      countUser,
      deleteUser,
      changeProfile,
      getUserHistory,
      countUserHistory,
      getAllUserHistory,
      getSubOrg,
      findProvince,
    },
    dispatch
  );
};
/**
 * Apis
 */

// const getUserApi = () => {
//     return apiCaller.get('/id/user/get-user')
// }

const getAllUserApi = (order, limit, skip, where) => {
  return apiCaller.getLogs(`/id/user`, { order, limit, skip, ...where });
};

const getSubOrgApi = () => {
  return apiCaller.getData(`/vnpost/province`);
};

const findProvinceApi = (name, limit) => {
  const filter = { where: { name: { regexp: `/.*${name}.*/i` } }, limit };
  return apiCaller.getData(`/vnpost/province`, { filter });
};

const getAllUserHistoryApi = () => {
  return apiCaller.getLogs(`/id/user`, null, { query: "all" });
};

const getUserHistoryApi = (order, limit, skip, where) => {
  return apiCaller.getLogs(`/id/history-log`, { order, limit, skip, ...where });
};

const countUserApi = (where) => {
  return apiCaller.getData(`/id/user/count`, { ...where });
};

const countUserHistoryApi = (where) => {
  return apiCaller.getData(`/id/history-log/count`, { ...where });
};

export const addUserApi = (payload) => {
  return apiCaller.postRequest(`/id/user`, payload);
};

export const editUserApi = ({ id, ...payload }) => {
  return apiCaller.putRequest(`/id/user/${id}`, payload);
};

const deleteUserApi = (id) => {
  return apiCaller.del(`/id/user/${id}`);
};

const logoutApi = () => {
  return apiCaller.post(`/id/user/logout`);
};
const changePasswordApi = (oldPassword, newPassword) => {
  return apiCaller.postRequest(`/id/user/change-password`, {
    oldPassword,
    newPassword,
  });
};

const changeProfileApi = (fullname, phoneNumber, address) => {
  return apiCaller.post(`/id/user/change-profile`, {
    fullname,
    phoneNumber,
    address,
  });
};

const getMenuApi = () => {
  return apiCaller.getLogs(`/portal-mgt/portal/info`);
};

/**
 * sagas
 */

// export const getProfileFlow = function* () {
//     while (true) {
//         yield take(GET_USER)
//         try {
//             const res = yield call(getUserApi)
//             yield put({
//                 type: GET_USER_SUCCESS, payload: {
//                     ...res.data
//                 }
//             })
//         } catch (error) {
//             yield put({ type: GET_USER_ERROR, error })
//         }
//     }
// }

export const changePasswordFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_PASSWORD);
    try {
      const res = yield call(
        changePasswordApi,
        action.data.oldPassword,
        action.data.newPassword
      );
      yield put({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: {
          ...res.data,
        },
      });
      const history = globalHistory();
      history.push(`${process.env.REACT_APP_PATH}/login`);
    } catch (error) {
      yield put({
        type: CHANGE_PASSWORD_ERROR,
        error: error.response?.data?.error?.message || error.message,
      });
    }
  }
};

export const getAllUserFlow = function* () {
  while (true) {
    const action = yield take(GET_ALL_USER);
    try {
      const res = yield call(
        getAllUserApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_ALL_USER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_ALL_USER_ERROR, error });
    }
  }
};

export const getSubOrgFlow = function* () {
  while (true) {
    yield take(GET_SUB_ORG);
    try {
      const res = yield call(getSubOrgApi);
      yield put({
        type: GET_SUB_ORG_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_SUB_ORG_ERROR, error });
    }
  }
};

export const findProvinceFlow = function* () {
  while (true) {
    const action = yield take(FIND_PROVINCE);
    try {
      const res = yield call(
        findProvinceApi,
        action.data.name,
        action.data.limit
      );
      yield put({ type: FIND_PROVINCE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: FIND_PROVINCE_ERROR, error });
    }
  }
};

export const getAllUserHistoryFlow = function* () {
  while (true) {
    yield take(GET_ALL_USER_HISTORY);
    try {
      const res = yield call(getAllUserHistoryApi);
      yield put({
        type: GET_ALL_USER_HISTORY_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_ALL_USER_HISTORY_ERROR, error });
    }
  }
};

export const getInfoFlow = function* () {
  while (true) {
    yield take(GET_INFO);
    try {
      const res = yield call(getMenuApi);
      yield put({ type: GET_INFO_SUCCESS, payload: { ...res.data } });
      document.title = res.data.name;
    } catch (error) {
      yield put({ type: GET_INFO_ERROR, error });
    }
  }
};

const changeStatusApi = (statusId) => {
  return apiCaller.post(`/call-center/agent/status/${statusId}`);
};

export const logoutFlow = function* () {
  while (true) {
    yield take(LOGOUT);
    const agentStatus = yield select((state) => state.agent.status);
    const user = yield select((state) => state.auth.init);
    // nếu là tài khoản chat, cập nhật lại trạng thái chat về pause khi logout
    if (
      user?.profile?.user?.role === "telephonist.service" ||
      user?.profile?.user?.role === "Supervisor"
    ) {
      try {
        window.globalThis.isLogoutProcess = true; // avoid case call changeAgentChatStatusApi two time
        changeAgentChatStatusApi("pause", true);
      } catch (error) {
        console.log("error", error);
      }
    }
    try {
      if (agentStatus.id != "") {
        const status = yield call(changeStatusApi, "stop");
        const res = yield call(logoutApi);
        yield put({
          type: LOGOUT_SUCCESS,
          payload: { ...status.data, ...res.data },
        });
        cookie.remove("access_token");
        document.location.reload();
      } else {
        const res = yield call(logoutApi);
        yield put({ type: LOGOUT_SUCCESS, payload: { ...res.data } });
        cookie.remove("access_token");
        document.location.reload();
      }
      // const history = globalHistory()
      // history.push(`${process.env.REACT_APP_PATH}/login`)
    } catch (error) {
      yield put({ type: LOGOUT_ERROR, error });
    }
  }
};

export const addUserFlow = function* () {
  while (true) {
    const action = yield take(ADD_USER);
    try {
      const res = yield call(addUserApi, action.data);
      yield put({
        type: ADD_USER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: ADD_USER_ERROR, error });
    }
  }
};

export const editUserFlow = function* () {
  while (true) {
    const action = yield take(EDIT_USER);
    try {
      const res = yield call(editUserApi, action.data);
      yield put({
        type: EDIT_USER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: EDIT_USER_ERROR, error });
    }
  }
};

export const deleteUserFlow = function* () {
  while (true) {
    const action = yield take(DELETE_USER);
    try {
      const res = yield call(deleteUserApi, action.data.id);
      yield put({
        type: DELETE_USER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: DELETE_USER_ERROR, error });
    }
  }
};

export const countUserFlow = function* () {
  while (true) {
    const action = yield take(COUNT_USER);
    try {
      const res = yield call(countUserApi, action.data.where);
      yield put({
        type: COUNT_USER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_USER_ERROR, error });
    }
  }
};

export const changeProfileFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_PROFILE);
    try {
      const res = yield call(
        changeProfileApi,
        action.data.fullname,
        action.data.phoneNumber,
        action.data.address
      );
      yield put({
        type: CHANGE_PROFILE_SUCCESS,
        payload: {
          ...res.data,
        },
      });
      setTimeout(() => window.location.reload(), 300);
    } catch (error) {
      yield put({ type: CHANGE_PROFILE_ERROR, error });
    }
  }
};

export const getUserHistoryFlow = function* () {
  while (true) {
    const action = yield take(GET_USER_HISTORY_LOG);
    try {
      const res = yield call(
        getUserHistoryApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_USER_HISTORY_LOG_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_USER_HISTORY_LOG_ERROR, error });
    }
  }
};

export const countUserHistoryFlow = function* () {
  while (true) {
    const action = yield take(COUNT_USER_HISTORY_LOG);
    try {
      const res = yield call(countUserHistoryApi, action.data.where);
      yield put({
        type: COUNT_USER_HISTORY_LOG_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_USER_HISTORY_LOG_ERROR, error });
    }
  }
};
